// @ts-nocheck
import { initialState } from './reducer';

const obsSelector = (state) => state.orderByStore || initialState;

export const getObsStoreColumns = (state) => {
	const { sku, store, warehouse, order } = obsSelector(state).columns;
	return { skuColumns: sku, storeColumns: store, warehouseColumns: warehouse, orderColumns: order || [] };
};

export const getObsStoreOrderData = (state) => obsSelector(state).orderData;

export const getObsStoreLoading = (state) => obsSelector(state).loading;
